<script setup>
import { Head, Link } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import AppLayout from '@/Layouts/AppLayout.vue'

defineOptions({ layout: AppLayout })

const { t } = useI18n()
</script>

<template>
  <Head><title>{{ t('errors.not_found.head_title') }}</title></Head>
  <section class="page">
    <p class="page__code">404</p>
    <h1 class="page__title">{{ t('errors.not_found.title') }}</h1>
    <p class="page__lede">{{ t('errors.not_found.lede') }}</p>
    <Link href="/" class="page__cta">{{ t('errors.not_found.cta_home') }}</Link>
  </section>
</template>

<style scoped>
.page { max-width: 32rem; margin: 4rem auto; padding: 0 1.5rem; text-align: center; }
.page__code { font-size: 0.75rem; font-weight: 600; letter-spacing: 0.15em; color: var(--muted); text-transform: uppercase; margin: 0 0 0.75rem; }
.page__title { font-family: var(--font-display, var(--display)); font-size: 1.75rem; margin: 0 0 0.5rem; color: var(--ink); font-weight: 700; letter-spacing: -0.01em; }
.page__lede  { color: var(--inkSoft); margin: 0 0 2rem; }
.page__cta   { display: inline-block; padding: 0.55rem 1.1rem; border-radius: var(--radius-button); background: var(--accent); color: var(--accentInk); text-decoration: none; font-weight: 500; font-size: 0.9rem; }
</style>
